module.exports = __webpack_public_path__ + "static/img/preview-06.9f7ac9f5.webp";